import { createAsyncThunk } from '@reduxjs/toolkit';
import { ToppingsCategory } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import {
  FindToppingsCategory,
  GetToppingsCategory,
} from '../../toppingsCategory/api/interface';

export const findSelectToppingsCategory = createAsyncThunk(
  'selectToppingsCategory/findSelectToppingsCategory',
  async (values: FindToppingsCategory, { rejectWithValue }) => {
    try {
      const response = await ToppingsCategory.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const searchSelectToppingsCategory = createAsyncThunk(
  'selectToppingsCategory/searchSelectToppingsCategory',
  async (values: FindToppingsCategory, { rejectWithValue }) => {
    try {
      const response = await ToppingsCategory.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getSelectToppingsCategory = createAsyncThunk(
  'selectToppingsCategory/getSelectToppingsCategory',
  async ({ id }: GetToppingsCategory, { rejectWithValue }) => {
    try {
      const response = await ToppingsCategory.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
